export default __webpack_public_path__ + "./assets/img/square-26f49b2fd39940007f607559c32d174a.png";